// Intake Part 1 step 2's own words (lane B13, DC-231: F-156, F-157) and the intake call's held-offline lines (DC-237,
// F-158), drawn by views/Intake.tsx. Every entry quotes his glossary (§6 rows *HM preferences & logistics* … *Logistics
// note*, §9 *Call held offline — continue · Held offline — continue · Held offline*) or the design system's Q-E15 list;
// the D0 label suites discover this module (a lane folder of src/views) and hold it to the same rules as src/mc.

import { defineLabels, template } from "@/mc/labels";

const STEP =
  "Intake Part 1, step 2, the Hiring Manager's before the call: **Preferred contact method** · **HM availability** · **Work-from-home policy** · **Relocation package** · **Travel** · **Internal candidates / referrals** · **Logistics note**";
const AVAILABILITY =
  "Drawn as **Window** (**30 minutes** · **1 hour**) → **Day** (a working day after today) → **Start** (half-hour starts between 08:00 and 18:00) → **Add window**; the windows are listed, each with **Remove**";
const RELOCATION = "A choice **Yes · No · Partial**";
const WFH =
  "One dropdown: **Remote** · **1 day at the office** · **2 days at the office** · **3 days at the office** · **4 days at the office** · **5 days at the office**";
const TRAVEL = "**Travel** is a choice **Yes · No**; when Yes, **Willing to travel** asks a percentage, 0–100 in steps of 5, optional";
const QE15_AVAILABILITY =
  "the descriptions *Remove every window to change the length* · *At most {max} windows*; the day's hint and error *A working day after today*";
const QE15_HELD = "Held offline (DC-237): *Held offline {date} — Part 2 is open.*";
const HELD = "the meeting then reads **Held offline · {reason}**";

/** Step 2 "HM preferences & logistics": its fields, in his order. */
export const LOGISTICS_LABELS = /* @__PURE__ */ defineLabels({
  section: { text: "HM preferences & logistics" },
  preferredContactMethod: { text: "Preferred contact method" },
  hmAvailability: { text: "HM availability" },
  workFromHomePolicy: { text: "Work-from-home policy" },
  relocationPackage: { text: "Relocation package" },
  travel: { text: "Travel" },
  internalCandidates: { text: "Internal candidates / referrals" },
  logisticsNote: { text: "Logistics note" },
});

/** HM availability: the window length first, then the day, then the start (DC-231). */
export const AVAILABILITY_LABELS = /* @__PURE__ */ defineLabels({
  window: { text: "Window" },
  thirtyMinutes: { text: "30 minutes" },
  oneHour: { text: "1 hour" },
  day: { text: "Day" },
  start: { text: "Start" },
  addWindow: { text: "Add window" },
  remove: { text: "Remove" },
  removeEveryWindow: { text: "Remove every window to change the length" },
  workingDayAfterToday: { text: "A working day after today" },
});

/** "At most 10 windows": Add window's description once ten are listed. */
export const atMostWindows = /* @__PURE__ */ template({ text: "At most {max} windows" });

/** The three choices of step 2 (F-157). */
export const CHOICE_LABELS = /* @__PURE__ */ defineLabels({
  yes: { text: "Yes" },
  no: { text: "No" },
  partial: { text: "Partial" },
  remote: { text: "Remote" },
  office1: { text: "1 day at the office" },
  office2: { text: "2 days at the office" },
  office3: { text: "3 days at the office" },
  office4: { text: "4 days at the office" },
  office5: { text: "5 days at the office" },
  willingToTravel: { text: "Willing to travel" },
});

/** The intake call held offline (DC-237): the strip card's line and the call card's line. */
export const heldOfflineReason = /* @__PURE__ */ template({ text: "Held offline · {reason}" });
export const heldOfflinePart2Open = /* @__PURE__ */ template({ text: "Held offline {date} — Part 2 is open." });
